import React from 'react'
import PropTypes from 'prop-types'

import { Box } from '@chatterbug/aaron'

const CardInfoSkeleton = ({
  titleSection,
  subtitleSection,
  descriptionSection,
  labelSection,
}) => {
  return (
    <Box>
      {/* Optional Icon, e.g. for media items */}
      {labelSection && <Box mb="1x">{labelSection}</Box>}
      {/* Title */}
      <Box variant="text.h5">{titleSection}</Box>
      {/* Subtitle */}
      <Box variant="text.subtitle">{subtitleSection}</Box>
      {/* Description */}
      <Box
        variant="text.paragraph"
        sx={{
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
        }}
      >
        {descriptionSection}
      </Box>
    </Box>
  )
}

CardInfoSkeleton.propTypes = {
  titleSection: PropTypes.any,
  subtitleSection: PropTypes.any,
  descriptionSection: PropTypes.any,
  labelSection: PropTypes.any,
}

export default CardInfoSkeleton
